"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.userGroup.list': '用户组',
    'route.userGroup.create': '添加用户组',
    'route.userGroup.edit': '编辑用户组',
};
